import { Carrier } from './Carrier';

export class Bus {
  id: number;
  vehicleNumber: string;
  capacity: number;
  carrier: Carrier;

  constructor(data?: any) {
    if (data) {
      Object.assign(this, data);
      this.carrier = data.carrier ? new Carrier(data.carrier) : null;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/model/Bus.ts